<template>
  <div class="highlights">
    <v-card v-for="card in cards" :key="card.code" outlined class="highlight-card">
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
          <img :src="card.flagUrl" alt="" class="tw-w-8 tw-h-6 tw-object-contain" />
          <span class="tw-text-sm tw-font-bold">{{ card.code }}</span>
          <span class="tw-text-xs tw-text-gray-600 tw-truncate">{{ card.name }}</span>
        </div>
        <span v-if="card.change.direction" :class="['change', `change--${card.change.direction}`]">
          <v-icon small :color="changeColor(card.change.direction)" aria-hidden="true">
            {{ changeIcon(card.change.direction) }}
          </v-icon>
          {{ card.change.direction === "flat" ? "เท่าเดิม" : card.change.text }}
          <span class="sr-only">{{ changeLabel(card.change.direction) }}</span>
        </span>
      </div>
      <div class="tw-text-2xl tw-font-bold tw-mt-2 numbers">{{ card.buy }}</div>
      <div class="tw-text-xs tw-text-gray-600 tw-mt-1 numbers">
        ซื้อ {{ buyLabel }} · ขาย {{ card.sell }} {{ unitName }}
      </div>
    </v-card>
  </div>
</template>

<script>
// Card colours: blue up / orange down, never red/green alone, and always
// with an arrow, so the change reads without colour.
const CHANGE = {
  up: { icon: "mdi-arrow-up", color: "#1F5FBF", label: "เพิ่มขึ้นจากวันก่อนหน้า" },
  down: { icon: "mdi-arrow-down", color: "#B54708", label: "ลดลงจากวันก่อนหน้า" },
  flat: { icon: "mdi-minus", color: "#5B6270", label: "เท่ากับวันก่อนหน้า" },
};

export default {
  name: "RateHighlights",
  props: {
    // [{ code, name, flagUrl, buy, sell, change: { direction, text } }]
    cards: { type: Array, required: true },
    buyLabel: { type: String, default: "" },
    unitName: { type: String, default: "" },
  },
  methods: {
    changeIcon(direction) {
      return CHANGE[direction].icon;
    },
    changeColor(direction) {
      return CHANGE[direction].color;
    },
    changeLabel(direction) {
      return CHANGE[direction].label;
    },
  },
};
</script>

<style lang="css" scoped>
.highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.highlight-card {
  padding: 14px 16px;
  border-radius: 12px !important;
}

.numbers {
  font-variant-numeric: tabular-nums;
}

.change {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.change--up {
  color: #1f5fbf;
}

.change--down {
  color: #b54708;
}

.change--flat {
  color: #5b6270;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
